if (!customElements.get('product-below-media')) {
  customElements.define('product-below-media', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      if (!this.product) return;
      this.mediaQuery = window.matchMedia('(min-width: 768px)');
      this.reposition = () => {
        this.product.querySelectorAll('[data-product-below-media]').forEach((block) => {
          const origin = Array.from(this.product.querySelectorAll('[data-product-block-origin]'))
            .find((marker) => marker.dataset.productBlockOrigin === block.dataset.productBelowMedia);
          if (!origin) return;
          if (this.mediaQuery.matches) {
            if (block.parentElement !== this) this.appendChild(block);
          } else if (origin.nextElementSibling !== block) {
            origin.after(block);
          }
        });
      };
      this.mediaQuery.addEventListener('change', this.reposition);
      this.reposition();
    }

    disconnectedCallback() {
      this.mediaQuery?.removeEventListener('change', this.reposition);
    }
  });
}
